export function parseCoordinateColumn(value: string): { lat: number | null; long: number | null } {
  if (!value || value.trim() === "") return { lat: null, long: null };

  const separators = [",", ";", /\s+/];
  for (const sep of separators) {
    const parts = value.split(sep).map((p) => p.trim()).filter((p) => p !== "");
    if (parts.length === 2) {
      const lat = parseFloat(parts[0]);
      const long = parseFloat(parts[1]);
      if (!isNaN(lat) && !isNaN(long) && Math.abs(lat) <= 90 && Math.abs(long) <= 180) {
        return { lat, long };
      }
    }
  }

  return { lat: null, long: null };
}

export function joinMultiColumnPhones(
  row: Record<string, string>,
  columns: string[],
  separator?: string
): string[] {
  if (!columns || columns.length === 0) return [];
  const result: string[] = [];

  for (const col of columns) {
    const val = row[col];
    if (val && val.trim() !== "") {
      if (separator) {
        val.split(separator).forEach((p) => {
          const trimmed = p.trim();
          if (trimmed !== "") result.push(trimmed);
        });
      } else {
        result.push(val.trim());
      }
    }
  }

  return result;
}

export function joinMultiColumnGroups(
  row: Record<string, string>,
  columns: string[],
  separator?: string
): string[] {
  if (!columns || columns.length === 0) return [];
  const result: string[] = [];

  for (const col of columns) {
    const val = row[col];
    if (val && val.trim() !== "") {
      if (separator) {
        val.split(separator).forEach((p) => {
          const trimmed = p.trim();
          if (trimmed !== "") result.push(trimmed);
        });
      } else {
        result.push(val.trim());
      }
    }
  }

  return result;
}

export function parseCropsFromColumns(
  row: Record<string, string>,
  columns: string[]
): Record<string, number> {
  if (!columns || columns.length === 0) return {};
  const result: Record<string, number> = {};

  for (const col of columns) {
    const val = row[col];
    if (val && val.trim() !== "") {
      const area = parseFloat(val);
      if (!isNaN(area)) {
        result[col] = area;
      }
    }
  }

  return result;
}

export function isCoordinateColumn(header: string): boolean {
  const normalized = header
    .toLowerCase()
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[\s_\-./\\]+/g, "");
  const coordAliases = [
    "latlong", "latlong", "latlng", "coordinates", "coords",
    "gps", "location", "ubicacion", "punto", "geo",
  ];
  return coordAliases.some(
    (a) => normalized === a || normalized.includes(a)
  );
}
